import { useRequest } from 'ahooks'
import { Button } from 'antd'
import { toInteger } from 'lodash'

import { queryAbortiveExplainApi } from '@eastcoal/api/trade/abortiveExplain/queryAbortiveExplain'

import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { useAuthStore } from '@eastcoal/auth/hooks/useStore'
import { RoleCode } from '@eastcoal/shared/enums/RoleCode'

import { AbortiveExplainStatus } from '../../../enums/AbortiveExplainStatus'
import { AuctionOperationPageStatus } from '../../../enums/AuctionOperationPageStatus'
import { useAuctionListStore } from '../../../Store/hooks/useStore'

import { AbortiveExplainDownloadButtonProps } from './interface'

export const AbortiveExplainDownloadButton = ({
  record
}: AbortiveExplainDownloadButtonProps) => {
  const roles = useAuthStore(state => state.roles)
  const hasPermission = roles.some(
    role =>
      role.code === RoleCode.SUPERADMIN ||
      role.code === RoleCode.CUSTMANAGER ||
      role.code === RoleCode.KINDMANAGER
  )
  const { status = 0, id = '', title, explainStatus = 0 } = record

  const { message } = useFeedback()
  const { previewRef } = useAuctionListStore(state =>
    pick(state, ['previewRef'])
  )

  const { refresh } = useRequest(
    () => queryAbortiveExplainApi({ auctionId: id }),
    {
      manual: true,
      onBefore: () => {
        message.loading({ content: '正在加载中....' })
      },
      onSuccess: data => {
        message.destroy()
        setTimeout(() => {
          doPreview(data.abortiveExplainOssId)
        }, 500)
      }
    }
  )

  const doPreview = (abortiveExplainOssId?: string) => {
    if (abortiveExplainOssId) {
      previewRef.current?.open({
        name: `流拍说明-${title}.pdf`,
        ossId: abortiveExplainOssId,
        type: 'pdf'
      })
    } else {
      message.warning('正在生成中,请稍后查看')
    }
  }

  return hasPermission &&
    AuctionOperationPageStatus.DEAL_FAIL === toInteger(status) &&
    AbortiveExplainStatus.SIGNING_SUCCESS === toInteger(explainStatus) ? (
    <Button type='link' onClick={refresh}>
      下载说明
    </Button>
  ) : null
}
